angular.module('mercury.modules.reports.transactions')
.factory('ReportsTransactions', ["$resource", "settings", function($resource, settings) {
  var SalesTransactions = $resource(settings.mercHost + '/pos/sales/transactions/:id', {id: '@id'});
  var OrdersTransactions = $resource(settings.mercHost + '/pos/orders/transactions/:id', {id: '@id'});

  function getSalesTransactions(start, end) {
    return SalesTransactions.query({
      start: start,
      end: end
    }).$promise;
  }

  function getOrdersTransactions(start, end) {
    return OrdersTransactions.query({
      start: start,
      end: end
    }).$promise;
  }

  function getSalesLines(id) {
    return SalesTransactions.query({id: id}).$promise;
  }

  function getOrdersLines(id) {
    return OrdersTransactions.query({id: id}).$promise;
  }

  return {
    getSalesTransactions: getSalesTransactions,
    getOrdersTransactions: getOrdersTransactions,
    getSalesLines: getSalesLines,
    getOrdersLines: getOrdersLines
  };
}]);
